import { combineReducers } from 'redux';
import { editorStateReducer as editorState } from './modules/editorState';
import pageview from 'redux/modules/pageview/pageview';
import notification from 'redux/modules/notification/notification';

// TODO: figure out a way to auto register reducers into combine reducer
// combineReducers determine the shape of the redux State
// http://rackt.org/redux/docs/api/combineReducers.html
// in this case, the state is { router, features, projects, user }
// A popular convention is to name reducers after the state
// slices they manage, so you can use ES6 property shorthand
// notation: combineReducers({ counter, todos }). This is
// equivalent to writing combineReducers({ counter: counter, todos: todos }).
export default combineReducers({
  editorState,
  pageview,
  notification
});

// Any reducer passed to combineReducers must satisfy these rules:
// 1) For any action that is not recognized, it must return the state given to it as the first argument.
// 2) It must never return undefined. It is too easy to do this by mistake via an early return statement,
// so combineReducers throws if you do that instead of letting the error manifest itself somewhere else.
// 3) If the state given to it is undefined, it must return the initial state for this specific reducer.
// According to the previous rule, the initial state must not be undefined either.
// It is handy to specify it with ES6 optional arguments syntax, but you can also explicitly
// check the first argument for being undefined.



/** WEBPACK FOOTER **
 ** ./src/redux/rootReducer.js
 **/